/*
打包到海外服务器，需要使用海外配置
*/
export const environment = 'oversea'

//export const environment = 'local'

export const updated ='2025/05/08 09:15'

export const sysVersion = "V6.14.31-260522"